
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'normal']),
  className: PropTypes.string,
};

const Panel = ({ className, children, variant = 'normal', ...other }) => {
  const componentClassName = classNames(className, 'ee_panel', `ee_panel--${variant}`);

  return (
    <div {...other} className={componentClassName}>
      {children}
    </div>
  );
};

Panel.propTypes = propTypes;

export default Panel;
